
<template>
    <div @click="toggleDropDown" class="flex items-center gap-2 cursor-pointer font-bold text-lg">
        <slot />
        <IconArrowLeft></IconArrowLeft>
        <div class="absolute left-0 right-0 container">
        <div v-show="dropDown === true" class="rounded  absolute  top-[44px] right-0 bg-white z-30 shadow-lg subcategory-container px-4 py-5">
            <div class="w-full overflow-y-auto" style="column-count: 4;column-fill: balance;column-gap: 0px;">
                <div v-for="(cat, idx) in $store.exhibitionCategories" :key="idx" class="w-full inline-block py-2">

                    <router-link class="font-semibold text-lg" :to="{ name: 'foods', query: { category: cat.id } }">{{ cat.name }}</router-link>

                    <div class="mt-1 pl-2 ">
                        <ul v-for="(sub, idx) in cat.subcategories" :key="idx" >
                            <router-link class="text-sm font-normal" :to="{ name: 'foods', query: { category: sub.id } }">{{ sub.name }}</router-link>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- <div v-for="(sub, idx) in cat.subcategories" :key="idx" class="px-8 py-10">

                <NuxtLink class="font-bold text-lg" :to="localePath(`/category/${sub.id}`)">{{ sub.name }}</NuxtLink>

                <div class="mt-5 grid grid-rows-8 grid-flow-col gap-2 grid-cols-4">
                    <NuxtLink v-for="(cls, idx) in sub.productClasses" :key="idx" class="text-sm" :to="localePath({ path: `/product-class/${cls.id}`, query: { cat : sub.id }})">{{ cls.name }}</NuxtLink>
                </div>
            </div> -->
        </div>
        </div>
    </div>
</template>
<script>
import { ref } from 'vue'
import { onClickOutside } from '@vueuse/core'
import { i18n } from '@/i18n'
import IconArrowLeft from "@icons/IconArrowLeft.vue";
export default {
    name: "FoodCategoriesMenu.vue",
    components: {
        IconArrowLeft
    },
    setup() {
        const dropDownContainer = ref()
        const dropDown = ref(false)
        onClickOutside(dropDownContainer, () => dropDown.value = false)
        const toggleDropDown = () => {
            dropDown.value = !dropDown.value
        }
        return {
            dropDownContainer,
            dropDown,
            toggleDropDown
        }
    },
    methods: {

    }
}
</script>

<style scoped>

</style>